import React from 'react';

const Blog = () => {
    return (
        <div><br /><br />
            <h3>this is blog</h3>
            <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
        </div>
    );
};

export default Blog;